import { render, staticRenderFns } from "./DeleteRequests.vue?vue&type=template&id=eb5596b2&scoped=true&"
import script from "./DeleteRequests.vue?vue&type=script&lang=js&"
export * from "./DeleteRequests.vue?vue&type=script&lang=js&"
import style0 from "./DeleteRequests.vue?vue&type=style&index=0&id=eb5596b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5596b2",
  null
  
)

export default component.exports